import React, { useState, useEffect } from 'react';
import { useUser } from '../context/UserContext';
import { validatedUpdatePhone, validatedUpdateEmail } from '.././utils/validateInputs'
import Modal from 'react-modal';

import './confirmationModal.css';

interface FormValues {
  name: string;
  lastName: string;
  motherLastName: string;
  phone: string;
  secondaryPhone: string;
  email: string;
  birthdate?: string;
}

interface ConfirmationModalProps {
  onRequestClose: () => void;
  onConfirm: () => void;
  formValues: FormValues | null;
  messageCode: string;
  isCorfirmationFailded: boolean;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({ onRequestClose, onConfirm, formValues, messageCode, isCorfirmationFailded }) => {
  const errorMessages: { [key: string]: string } = {
    invalid_hour: 'Hora no válida.',
    invalid_patient: 'Usuario no válido.',
    invalid_hour_scheduled: 'Hora no válida.',
    email_exists: 'Este email ya está asociado a otro paciente, por favor intente con un correo diferente.',
    hour_could_not_scheduled: 'Ha ocurrido un error inesperado, la hora no ha podido ser agendada.',
    default: 'Ha ocurrido un error, por favor intente con otra hora.'
  }
  const [dataIsUpdating, setDataIsUpdating] = useState(false);
  const { user } = useUser();

  const updateData = () => {
    if (user.phone !== formValues?.phone && validatedUpdatePhone(formValues?.phone)) {
      setDataIsUpdating(true);
    }
    else if (user.secondaryPhone !== formValues?.secondaryPhone && validatedUpdatePhone(formValues?.secondaryPhone)) {
      setDataIsUpdating(true);
    }
    else if (user.email !== formValues?.email && validatedUpdateEmail(formValues?.email)) {
      setDataIsUpdating(true);
    }
  }

  useEffect(() => {
    updateData()
  }, [formValues, user]);

  return (
    <Modal isOpen={true} onRequestClose={onRequestClose} contentLabel="Confirm Modal" className="confirmModal" overlayClassName="overlay">
      <div className="confirmModal-header">
        <button onClick={onRequestClose} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Cerrar"></button>
      </div>
      <div className="confirmModal-body">
        {dataIsUpdating ? <p>¿Está seguro de que desea confirmar su reserva?</p> : <p>¿Está seguro de que desea confirmar su cita sin actualizar sus datos?</p>}
      </div>
      {isCorfirmationFailded &&
          <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-10">
              <div className="alert alert-danger text-center" role="alert">
                {errorMessages[messageCode] ? <p>{errorMessages[messageCode]}</p> : ''}
              </div>
            </div>
          </div>
        </div>
      }
      <div className="confirmModal-footer">
        {dataIsUpdating ? <button onClick={onRequestClose}>Cancelar</button> : <button onClick={onRequestClose}>Volver a modificar datos</button>}
        <button onClick={onConfirm} className={!dataIsUpdating ? 'notupdating' : ''}>Confirmar</button>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
